module.exports = __webpack_public_path__ + "static/media/73.33894ef8.png";